import { ModelBase } from 'store/model-base';

export class CmsOneTimePasscode extends ModelBase {
    public static storeName: string = 'cmsOneTimePasscode';
    
    public title: string;
    public description: string[];
    public primaryButton: string;
    public secondaryButton: string;
    public resendButton: string;
    public doneButton: string;
    public findXfinityStore: string;
    public emailCodeButton: string;
    public helpText: string;
    public errors: CmsOneTimePasscodeErrors;
    public placeholderPhoneImage: CmsMediaImage;
}
